__turbopack_context__.v({
  "disabledMessage": "kU5M5q_disabledMessage",
  "error": "kU5M5q_error",
  "fieldset": "kU5M5q_fieldset",
  "form": "kU5M5q_form",
  "formEmpty": "kU5M5q_formEmpty",
  "input": "kU5M5q_input",
  "legend": "kU5M5q_legend",
  "prompt": "kU5M5q_prompt",
  "srLabel": "kU5M5q_srLabel",
  "star": "kU5M5q_star",
  "starLabel": "kU5M5q_starLabel",
  "stars": "kU5M5q_stars",
  "starsDisabled": "kU5M5q_starsDisabled",
});
